export default "__VITE_ASSET__3BcB7Z71__";